import ActionType from 'actions/ActionType'

export const schemaObj = {
  POST: {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/main.CreateSignupFormRequest',
    definitions: {
      'main.CreateSignupFormRequest': {
        required: [
          'name',
          'title',
          'display_type',
          'contact_fields',
          'contactgroup_ids',
          'button',
          'background_color',
          'font',
          'text_color',
        ],
        properties: {
          background_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          button: {
            $ref: '#/definitions/signupforms.ButtonConfig',
          },
          contact_fields: {
            items: {
              $ref: '#/definitions/signupforms.ContactField',
            },
            minItems: 1,
            type: 'array',
          },
          contactgroup_ids: {
            items: {
              type: 'string',
            },
            minItems: 1,
            type: 'array',
          },
          description: {
            $ref: '#/definitions/signupforms.DescriptionText',
          },
          display_type: {
            enum: ['popover', 'embedded'],
            type: 'string',
          },
          font: {
            maxLength: 64,
            minLength: 4,
            type: 'string',
          },
          name: {
            maxLength: 128,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
          text_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          title: {
            $ref: '#/definitions/signupforms.TitleText',
          },
        },
        // errorMessage: {
        //   properties: {
        //     name:
        //       'Must be between 1 and 128 characters long. No leading or trailing spaces.',
        //   },
        // },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.ButtonConfig': {
        required: ['text', 'text_color', 'background_color'],
        properties: {
          background_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 64,
            minLength: 1,
            type: 'string',
          },
          text_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
        },
        // errorMessage: {
        //   properties: {
        //     text:
        //       'Must be between 1 and 64 characters long. No leading or trailing spaces.',
        //   },
        // },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.ContactField': {
        required: ['field_name', 'required'],
        properties: {
          field_name: {
            type: 'string',
          },
          required: {
            type: 'boolean',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.DescriptionText': {
        required: ['color', 'text'],
        properties: {
          color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 255,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
        },
        // errorMessage: {
        //   properties: {
        //     text:
        //       'Must be between 1 and 255 characters long. No leading or trailing spaces.',
        //   },
        // },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.TitleText': {
        required: ['color', 'text'],
        properties: {
          color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 64,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
        },
        // errorMessage: {
        //   properties: {
        //     text:
        //       'Must be between 1 and 64 characters long. No leading or trailing spaces.',
        //   },
        // },
        additionalProperties: false,
        type: 'object',
      },
    },
  },
  PUT: {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/main.UpdateSignupFormRequest',
    definitions: {
      'main.UpdateSignupFormRequest': {
        required: [
          'id',
          'name',
          'title',
          'display_type',
          'contact_fields',
          'contactgroup_ids',
          'button',
          'background_color',
          'font',
          'text_color',
        ],
        properties: {
          background_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          button: {
            $ref: '#/definitions/signupforms.ButtonConfig',
          },
          contact_fields: {
            items: {
              $ref: '#/definitions/signupforms.ContactField',
            },
            minItems: 1,
            type: 'array',
          },
          contactgroup_ids: {
            items: {
              type: 'string',
            },
            minItems: 1,
            type: 'array',
          },
          description: {
            $ref: '#/definitions/signupforms.DescriptionText',
          },
          display_type: {
            enum: ['popover', 'embedded'],
            type: 'string',
          },
          font: {
            maxLength: 64,
            minLength: 4,
            type: 'string',
          },
          id: {
            type: 'string',
          },
          name: {
            maxLength: 128,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
          text_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          title: {
            $ref: '#/definitions/signupforms.TitleText',
          },
          when_created: {
            type: 'string',
            format: 'date-time',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.ButtonConfig': {
        required: ['text', 'text_color', 'background_color'],
        properties: {
          background_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 64,
            minLength: 1,
            type: 'string',
          },
          text_color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.ContactField': {
        required: ['field_name', 'required'],
        properties: {
          field_name: {
            type: 'string',
          },
          required: {
            type: 'boolean',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.DescriptionText': {
        required: ['color', 'text'],
        properties: {
          color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 255,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
      'signupforms.TitleText': {
        required: ['color', 'text'],
        properties: {
          color: {
            pattern: '^#[0-9a-f]{6}$',
            type: 'string',
          },
          text: {
            maxLength: 64,
            minLength: 1,
            type: 'string',
            pattern: '^[^ ].*[^ ]$',
          },
        },
        additionalProperties: false,
        type: 'object',
      },
    },
  },
}

export default (
  state = {},
  action,
) => {
  switch (action.type) {
    case ActionType.SignupForm.SCHEMA_SUCCESS:
      return {
        ...state,
        [action.payload.schemaType]: action.payload.schema,
      }
    default:
      return state
  }
}
